import { FC } from 'react';
import { useTheme } from '@mui/material/styles';
import {
  StyledStatusAbbreviation,
  StyledStatusCircle,
} from '../styled/community-trades-table.styled';
import type { StatusIconProps } from '../types';

const SelectedCheckIcon: FC<{ circleFill: string; checkFill: string }> = ({
  circleFill,
  checkFill,
}) => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16.1461" cy="16.1461" r="16.1461" fill={circleFill} />
    <path
      d="M20.4837 13.3775C20.5939 13.4878 20.6558 13.6373 20.6558 13.7932C20.6558 13.9491 20.5939 14.0986 20.4837 14.2089L14.9935 19.6991C14.8833 19.8092 14.7337 19.8711 14.5779 19.8711C14.422 19.8711 14.2725 19.8092 14.1622 19.6991L11.8092 17.3461C11.7053 17.2346 11.6488 17.0871 11.6514 16.9347C11.6541 16.7823 11.7159 16.6369 11.8236 16.5292C11.9314 16.4214 12.0768 16.3596 12.2292 16.357C12.3816 16.3543 12.5291 16.4108 12.6406 16.5147L14.5779 18.451L19.6524 13.3775C19.7627 13.2673 19.9122 13.2055 20.0681 13.2055C20.2239 13.2055 20.3734 13.2673 20.4837 13.3775ZM26.1465 16.1461C26.1465 18.1239 25.56 20.0573 24.4612 21.7018C23.3624 23.3463 21.8006 24.628 19.9733 25.3849C18.1461 26.1418 16.1354 26.3398 14.1956 25.954C12.2558 25.5681 10.4739 24.6157 9.07542 23.2172C7.6769 21.8187 6.72449 20.0368 6.33864 18.097C5.95278 16.1572 6.15082 14.1465 6.90769 12.3193C7.66457 10.492 8.94629 8.93024 10.5908 7.83142C12.2353 6.73261 14.1687 6.14612 16.1465 6.14612C18.7977 6.14923 21.3394 7.2038 23.2141 9.07849C25.0888 10.9532 26.1434 13.4949 26.1465 16.1461ZM24.97 16.1461C24.97 14.401 24.4525 12.695 23.483 11.244C22.5134 9.79301 21.1354 8.66207 19.5231 7.99424C17.9108 7.32641 16.1367 7.15167 14.4251 7.49213C12.7135 7.83259 11.1413 8.67295 9.90731 9.90694C8.67332 11.1409 7.83296 12.7131 7.4925 14.4247C7.15204 16.1363 7.32678 17.9104 7.99461 19.5227C8.66244 21.135 9.79338 22.5131 11.2444 23.4826C12.6954 24.4522 14.4014 24.9696 16.1465 24.9696C18.4858 24.967 20.7286 24.0366 22.3828 22.3824C24.037 20.7283 24.9674 18.4855 24.97 16.1461Z"
      fill={checkFill}
    />
  </svg>
);

/**
 * StatusIcon Component
 * When row is active/selected: shows themed circle with checkmark
 * When row is not active: shows currency abbreviation in a circle
 */
export const StatusIcon: FC<StatusIconProps> = ({ abbreviation, isActive }) => {
  const theme = useTheme();

  if (isActive) {
    return (
      <SelectedCheckIcon
        circleFill={theme.palette.primary.main}
        checkFill={theme.palette.primary.contrastText}
      />
    );
  }

  return (
    <StyledStatusCircle>
      <StyledStatusAbbreviation>{abbreviation}</StyledStatusAbbreviation>
    </StyledStatusCircle>
  );
};
